<template>
  <form ref="form" class="contact-form">
    <div class="row">
      <input
        type="text"
        :placeholder="'*' + translations.contactFormFirstName"
        name="firstName"
        required
        maxlength="64"
        pattern="^\S\D+\S$"
        @input="onInputUpdate($event)"
        @focus="reportFieldValidity($event)"
        @blur="setFieldToValidate($event.target.name), reportScreenSizeUpdate($event)"
        v-model="formData.firstName"
        :readonly="!!formData.firstName && preFilled"
        :class="{ 'contact-form-validate-field': fieldsToValidate.firstName }"
      />

      <input
        type="text"
        :placeholder="'*' + translations.contactFormLastName"
        name="lastName"
        required
        maxlength="64"
        pattern="^\S\D+\S$"
        @input="onInputUpdate($event)"
        @focus="reportFieldValidity($event)"
        @blur="setFieldToValidate($event.target.name), reportScreenSizeUpdate($event)"
        v-model="formData.lastName"
        :readonly="!!formData.lastName && preFilled"
        :class="{ 'contact-form-validate-field': fieldsToValidate.lastName }"
      />

      <input
        type="email"
        :placeholder="'*' + translations.contactFormEmail"
        name="emailAddress"
        required
        maxlength="250"
        @input="onInputUpdate($event)"
        @focus="reportFieldValidity($event)"
        @blur="setFieldToValidate($event.target.name), reportScreenSizeUpdate($event)"
        @keyup.enter="setFieldToValidate($event.target.name), reportFieldValidity($event)"
        v-model="formData.emailAddress"
        :readonly="!!formData.emailAddress && preFilled"
        :class="{ 'contact-form-validate-field': fieldsToValidate.emailAddress }"
      />
    </div>
  </form>
</template>

<script>
import { sessionKeys } from '@/data/constants';

export default {
  name: "termsConditionsContactForm",
  props: {
    contactDetails: {
      type: Object,
      required: false,
    },
    reportFieldBlur: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    }
  },
  data() {
    return {
      currentValidityState: null,
      fieldsToValidate: {
        firstName: false,
        lastName: false,
        emailAddress: false,
      },
      formData: {
        firstName: "",
        lastName: "",
        emailAddress: "",
      },
      preFilled: false
    }
  },
  methods: {
    checkValidity() {
      return (this.$refs.form.checkValidity()
        && this.$store.getters["utils/isValidEmail"]({ email: this.formData.emailAddress })
      );
    },

    /**
     * @function reportScreenSizeUpdate
     * Emits event on blur to parent to recalculate the screen size of customizer
     * Needed on mobile when the keyboard is opened to reset the view positioning
     */
    reportScreenSizeUpdate() {
      if (this.reportFieldBlur && this.isMobile) {
        this.$emit("field-blur-event");
      }
    },

    setFieldToValidate(fieldName) {
      this.fieldsToValidate[fieldName] = true;
    },

    onInputUpdate(event) {
      // checks the validity of the field
      const { name, type } = event.target;
      if (type === "text") this.fieldsToValidate[name] = true;
      this.reportFieldValidity(event);

      // checks the validity of the whole form
      const isFormValid = this.checkValidity();

      if (this.currentValidityState !== isFormValid) {
        this.currentValidityState = isFormValid;
        this.$emit("validity-update", isFormValid);
      }
    },

    reportFieldValidity(event) {
      const field = event.target;
      const { name, type } = event.target;
      if (this.fieldsToValidate[name]) {
        // reset previous custom error
        field.setCustomValidity("");
        if (!field.checkValidity() || (type === "email" && !this.$store.getters["utils/isValidEmail"]({ email: this.formData.emailAddress }))) {
          if (type === "text" && field.validity.patternMismatch) {
            field.setCustomValidity("No numbers or empty field are allowed");
          } else if (type === "email" && !field.validity.typeMismatch && !this.$store.getters["utils/isValidEmail"]({ email: this.formData.emailAddress })) {
            field.setCustomValidity("Please enter a valid email address");
          }
        }

        field.reportValidity();
      }
    },
  },
  mounted() {
    if (this.checkValidity()) {
      this.$emit("validity-update", true);
    }
  },
  beforeMount() {
    const contactDetails = this.$cookies.get(sessionKeys.ugcContactDetailsFilled) || this.$store.state.UGCEntryPoint.contactDetails;
    this.formData = {
      ...this.formData,
      ...contactDetails
    };
    if (this.$cookies.get(sessionKeys.ugcContactDetailsFilled)) {
      this.preFilled = true;
    }
  },
  beforeDestroy() {
    this.$emit("contact-details-update", this.formData);
  }
};
</script>
